module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-active-bg-right.5ff51943.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-active-bg-right.png
// module id = 3602
// module chunks = 11